<template>
  <div class="health-website">
    <!-- 导航栏 -->
    <header class="navbar">
      <div class="container" style="max-width: 100%;">
        <div class="logo">
          <img src="/hhwl.png" alt="北京和合网链科技有限公司" />
          <span>北京和合网链科技有限公司</span>
        </div>
        <nav class="nav-links">
          <router-link to="/" class="nav-link" style="color: #3498db;">首页</router-link>
          <router-link to="/health-detection" class="nav-link">健康检测</router-link>
          <router-link to="/health-management" class="nav-link">健康管理</router-link>
          <router-link to="/conditioning-service" class="nav-link">调理服务</router-link>
          <router-link to="/expert-team" class="nav-link">专家团队</router-link>
          <router-link to="/news" class="nav-link">行业资讯</router-link>
          <router-link to="/cases" class="nav-link">成功案例</router-link>
          <router-link to="/appointment-service" class="nav-link">预约服务</router-link>
        </nav>
        <div class="user-actions" style="width: 414.34px;">
          <button @click="feedBack=true" class="nav-btn">结果反馈</button>
          <button @click="reservationConditioning=true" class="nav-btn">查看预约</button>
          <button @click="reservationPromptClick" class="nav-btn">预约状态</button>
          <button @click="showPdf()" class="nav-btn">检测结果</button>
          <button v-if="!phone" @click="login=true" class="nav-btn login-btn">登录/注册</button>
          <button v-else class="nav-btn login-btn">{{ '已登录' }}</button>
        </div>
      </div>
    </header>

    <!-- 首页轮播 -->
    <section id="home" class="hero">
      <div class="hero-content">
        <h1>北京和合网链科技有限公司</h1>
        <p>专业的量子健康服务平台，为您的健康保驾护航</p>
        <div class="hero-buttons">
          <button @click="toReservation" class="cta-btn primary">立即预约</button>
          <button @click="goToHealthDetection" class="cta-btn secondary">健康检测</button>
          <button @click="goToExpertTeam" class="cta-btn secondary">专家咨询</button>
        </div>
        <div class="hero-info">
          <span>今日剩余名额 {{ number }} 人</span>
        </div>
      </div>
    </section>

    <!-- 关于我们 -->
    <section id="about" class="about">
      <div class="container">
        <h2 class="section-title">关于我们</h2>
        <div class="about-content">
          <div class="about-text">
            <h3>北京和合网链科技有限公司</h3>
            <p>北京和合网链科技有限公司是一家专注于健康科技领域的创新型企业，致力于通过先进的技术手段，为用户提供专业、便捷的健康管理服务。</p>
            <p>公司拥有一支由健康专家、技术研发人员和服务团队组成的专业队伍，结合传统健康理念与现代科技，为用户打造个性化的健康管理方案。目前，正在探索睡眠管理的全面解决方案。</p>
            <p>我们的使命是让每个人都能享受到专业的健康服务，守护您和家人的健康。公司秉承"以用户为中心，以科技为支撑，以服务为保障"的发展理念，不断创新产品和服务，提升用户体验。</p>
            <p>作为健康科技领域的先行者，我们始终坚持"科技赋能健康"的核心价值观，致力于推动健康产业的数字化、智能化发展，为构建健康中国贡献力量。</p>
            <p>未来，我们将继续深耕健康科技领域，不断推出更多优质的健康管理产品和服务，为用户提供全方位、个性化的健康解决方案。</p>
          </div>
          <div class="about-image">
            <img src="img/company.jpg" alt="公司形象展示" />
          </div>
        </div>
      </div>
    </section>

    <!-- 核心服务 -->
    <section id="services" class="services">
      <div class="container">
        <h2 class="section-title">核心服务</h2>
        <div class="services-grid">
          <div class="service-card" @click="goToHealthDetection">
            <div class="service-icon">🏥</div>
            <h3>健康检测</h3>
            <p>提供专业的健康检测服务，帮助您了解自身健康状况</p>
          </div>
          <div class="service-card" @click="goToExpertTeam">
            <div class="service-icon">👨‍⚕️</div>
            <h3>专家咨询</h3>
            <p>资深专家团队为您提供专业的健康咨询服务</p>
          </div>
          <div class="service-card" @click="goToHealthManagement">
            <div class="service-icon">📋</div>
            <h3>健康管理</h3>
            <p>个性化的健康管理方案，助您保持健康生活方式</p>
          </div>
          <div class="service-card" @click="goToConditioningService">
            <div class="service-icon">💊</div>
            <h3>调理服务</h3>
            <p>专业的健康调理服务，改善您的身体状态</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 专家团队 -->
    <section id="experts" class="experts">
      <div class="container">
        <h2 class="section-title">专家团队</h2>
        <div class="experts-grid">
          <div class="expert-card" v-for="(expert, index) in experts" :key="index" @click="goToExpertTeam">
            <div class="expert-avatar">{{ expert.avatar }}</div>
            <h3>{{ expert.name }}</h3>
            <p class="expert-title">{{ expert.title }}</p>
            <p class="expert-bio">{{ expert.bio }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 行业资讯 -->
    <section id="news" class="news">
      <div class="container">
        <h2 class="section-title">行业资讯</h2>
        <div class="news-grid">
          <div class="news-card" @click="goToNewsDetail">
            <div class="news-date">2026-05-20</div>
            <h3>量子健康技术在医疗领域的最新应用</h3>
            <p>量子健康技术作为新兴领域，正在医疗行业展现出巨大潜力。最新研究表明，量子检测技术能够更准确地预测健康风险...</p>
            <a href="#" class="read-more" @click.stop="goToNewsDetail">阅读更多</a>
          </div>
          <div class="news-card" @click="goToNewsDetail">
            <div class="news-date">2026-05-15</div>
            <h3>健康管理行业发展趋势分析</h3>
            <p>随着人们健康意识的提高，健康管理行业呈现快速发展态势。个性化、智能化的健康服务将成为未来发展的主要方向...</p>
            <a href="#" class="read-more" @click.stop="goToNewsDetail">阅读更多</a>
          </div>
          <div class="news-card" @click="goToNewsDetail">
            <div class="news-date">2026-05-10</div>
            <h3>如何通过科学方式提升免疫力</h3>
            <p>免疫力是人体抵御疾病的重要防线。本文将介绍几种科学有效的方法，帮助您提升免疫力，保持健康状态...</p>
            <a href="#" class="read-more" @click.stop="goToNewsDetail">阅读更多</a>
          </div>
        </div>
      </div>
    </section>

    <!-- 常见问题 -->
    <section id="faq" class="faq">
      <div class="container">
        <h2 class="section-title">常见问题</h2>
        <div class="faq-list">
          <div class="faq-item">
            <h3 class="faq-question">什么是量子健康检测？</h3>
            <div class="faq-answer">
              <p>量子健康检测是一种基于量子物理学原理的非侵入式健康评估技术，通过检测人体生物电场的变化，分析身体健康状况，预测潜在健康风险。</p>
            </div>
          </div>
          <div class="faq-item">
            <h3 class="faq-question">预约检测需要准备什么？</h3>
            <div class="faq-answer">
              <p>预约量子健康检测时，建议您保持放松状态，避免过度劳累和情绪波动。检测前1小时内请勿进食过饱或饮用刺激性饮料。</p>
            </div>
          </div>
          <div class="faq-item">
            <h3 class="faq-question">检测结果需要多久才能出来？</h3>
            <div class="faq-answer">
              <p>一般情况下，检测结果会在检测完成后的1-2个工作日内生成。您可以通过我们的在线系统查询检测报告，或选择由我们的客服人员为您解读报告。</p>
            </div>
          </div>
          <div class="faq-item">
            <h3 class="faq-question">量子健康检测的准确率如何？</h3>
            <div class="faq-answer">
              <p>量子健康检测的准确率受到多种因素影响，包括检测设备的精度、检测环境的稳定性以及受测者的状态等。我们采用先进的检测设备和标准化的检测流程，确保检测结果的可靠性。</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 成功案例 -->
    <section id="cases" class="cases">
      <div class="container">
        <h2 class="section-title">成功案例</h2>
        <div class="cases-grid">
          <div class="case-card" @click="goToCaseDetail">
            <div class="case-image">
              <img src="img/case-enterprise.jpg" alt="企业健康管理案例" />
            </div>
            <div class="case-content">
              <h3>某大型企业员工健康管理项目</h3>
              <p>为某大型企业提供员工健康管理服务，通过量子检测技术定期评估员工健康状况，建立健康档案，提供个性化健康建议，有效降低了员工缺勤率和医疗费用支出。</p>
            </div>
          </div>
          <div class="case-card" @click="goToCaseDetail">
            <div class="case-image">
              <img src="img/case-community.jpg" alt="社区健康服务案例" />
            </div>
            <div class="case-content">
              <h3>社区健康服务中心合作项目</h3>
              <p>与多家社区健康服务中心合作，引入量子健康检测设备，为社区居民提供便捷的健康检测服务，提升了社区健康服务水平，受到居民的广泛好评。</p>
            </div>
          </div>
          <div class="case-card" @click="goToCaseDetail">
            <div class="case-image">
              <img src="img/case-chronic.jpg" alt="慢性病管理案例" />
            </div>
            <div class="case-content">
              <h3>慢性病患者健康管理项目</h3>
              <p>针对高血压、糖尿病等慢性病患者，提供长期健康管理服务，通过定期检测和个性化干预方案，有效控制了患者的病情，提高了生活质量。</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 联系我们 -->
    <section id="contact" class="contact">
      <div class="container">
        <h2 class="section-title">联系我们</h2>
        <div class="contact-content">
          <div class="contact-info">
            <h3>公司信息</h3>
            <p><strong>公司名称：</strong>北京和合网链科技有限公司</p>
            <p><strong>地址：</strong>北京市丰台区南三环西路91号院1号楼14层1单元1706</p>
            <p><strong>电话：</strong>15383753755</p>
            <p><strong>邮箱：</strong>james@tssen.com</p>
          </div>
          <div class="contact-form">
            <h3>在线留言</h3>
            <el-form>
              <el-form-item label="姓名">
                <el-input placeholder="请输入您的姓名"></el-input>
              </el-form-item>
              <el-form-item label="电话">
                <el-input placeholder="请输入您的电话"></el-input>
              </el-form-item>
              <el-form-item label="留言内容">
                <el-input type="textarea" placeholder="请输入您的留言" :rows="4"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" class="submit-btn">提交留言</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </section>

    <!-- 底部 -->
    <footer class="footer">
      <div class="container">
        <div class="footer-content">
          <div class="footer-info">
            <h3>北京和合网链科技有限公司</h3>
            <p>专注健康科技，守护您的健康</p>
            <div class="contact-info">
              <p><i class="el-icon-location"></i> 地址：北京市丰台区南三环西路91号院1号楼14层1单元1706</p>
              <p><i class="el-icon-phone"></i> 电话：15383753755</p>
              <p><i class="el-icon-message"></i> 邮箱：james@tssen.com</p>
            </div>
          </div>
          <div class="footer-links-group">
            <div class="footer-links">
              <h4>快速导航</h4>
              <a href="#home">首页</a>
              <a href="#about">关于我们</a>
              <a href="#services">服务介绍</a>
              <a href="#contact">联系我们</a>
            </div>
            <div class="footer-services">
              <h4>服务项目</h4>
              <a href="#">健康检测</a>
              <a href="#">专家咨询</a>
              <a href="#">健康管理</a>
              <a href="#">调理服务</a>
            </div>
            <div class="footer-social">
              <h4>关于我们</h4>
              <div class="social-icons">
                <a href="#" class="social-icon"><i class="el-icon-message-solid"></i> 官方客服</a>
              </div>
            </div>
          </div>
        </div>
        <div class="footer-bottom">
          <div class="copyright">
            <p style="font-size: 12px;" @click="toIcp">© 2026 北京和合网链科技发展有限公司 版权所有</p>
          </div>
        </div>
      </div>
    </footer>

    <!-- 原有弹窗组件 -->
    <el-dialog
      title=""
      :visible.sync="login"
      width="40%"
    >
      <div style="text-align: center;font-size: 22px;color: black;font-weight: 400;">欢迎登录</div>
      <div class="noInput">
        <div style="margin-left: 30px;font-size: 14px;color: black;margin-top: 30px;">手机号</div>
        <el-input v-model="loginName" placeholder="请输入手机号" style="margin-top: 20px;margin-left: 30px;width: calc(100% - 60px);margin-right: 30px;"></el-input>

        <div style="margin-left: 30px;font-size: 14px;color: black;margin-top: 30px;">密码</div>
        <el-input type="password" v-model="loginPass" placeholder="请输入密码" style="margin-top: 20px;margin-left: 30px;width: calc(100% - 60px);margin-right: 30px;"></el-input>
      </div>

      <div @click="loginF" style="cursor: pointer;margin-top: 25px;margin-left: 30px;width: calc(100% - 60px);margin-right: 30px;background-color: #1890FF;color: white;border-radius: 25px;height: 40px;line-height: 40px;text-align: center;">登 录</div>
      <div style="height: 30px;margin-top: 20px;">
        <div @click="registerName='';registerCode='';registerPass='';registerPass2='';forget=true;login=false;" style="float: left;color: #1890FF;margin-left: 30px;cursor: pointer;">忘记密码</div>
        <div @click="registerName='';registerCode='';registerPass='';registerPass2='';register=true;login=false;" style="float: right;color: #1890FF;margin-right: 30px;cursor: pointer;">立即注册</div>
      </div>
    </el-dialog>

    <el-dialog
      title=""
      :visible.sync="register"
      width="40%"
    >
      <div style="text-align: center;font-size: 22px;color: black;font-weight: 400;">账号注册</div>
      <div class="noInput">
        <div style="margin-left: 30px;font-size: 14px;color: black;margin-top: 30px;">手机号</div>
        <el-input v-model="registerName" placeholder="请输入手机号" style="margin-top: 20px;margin-left: 30px;width: calc(100% - 60px);margin-right: 30px;"></el-input>
        <div style="margin-left: 30px;font-size: 14px;color: black;margin-top: 30px;">验证码</div>
        <div>
          <el-input maxlength="4" v-model="registerCode" placeholder="请输入验证码" style="margin-top: 20px;margin-left: 30px;width: calc(100% - 60px);margin-right: 30px;"></el-input>
          <div @click="sendSms" :style="{color: '#1890FF',position: 'relative',top: '-30px',left:flag?'calc(100% - 100px)':'calc(100% - 50px)',cursor: 'pointer'}">{{ time }}</div>
        </div>

        <div style="margin-left: 30px;font-size: 14px;color: black;margin-top: 30px;">密码</div>
        <el-input type="password" v-model="registerPass" placeholder="请输入密码" style="margin-top: 20px;margin-left: 30px;width: calc(100% - 60px);margin-right: 30px;"></el-input>
        <div style="margin-left: 30px;font-size: 14px;color: black;margin-top: 30px;">确认密码</div>
        <el-input type="password" v-model="registerPass2" placeholder="请再次输入密码" style="margin-top: 20px;margin-left: 30px;width: calc(100% - 60px);margin-right: 30px;"></el-input>
      </div>
      
      <div @click="siginIn" style="cursor: pointer;margin-top: 25px;margin-left: 30px;width: calc(100% - 60px);margin-right: 30px;background-color: #1890FF;color: white;border-radius: 25px;height: 40px;line-height: 40px;text-align: center;">立 即 注 册</div>
    </el-dialog>

    <el-dialog
      title=""
      :visible.sync="forget"
      width="40%"
    >
      <div style="text-align: center;font-size: 22px;color: black;font-weight: 400;">忘记密码</div>
      
      <div class="noInput">
        <div style="margin-left: 30px;font-size: 14px;color: black;margin-top: 30px;">手机号</div>
        <el-input v-model="registerName" placeholder="请输入手机号" style="margin-top: 20px;margin-left: 30px;width: calc(100% - 60px);margin-right: 30px;"></el-input>
        <div style="margin-left: 30px;font-size: 14px;color: black;margin-top: 30px;">验证码</div>
        <div>
          <el-input maxlength="4" v-model="registerCode" placeholder="请输入验证码" style="margin-top: 20px;margin-left: 30px;width: calc(100% - 60px);margin-right: 30px;"></el-input>
          <div @click="sendSms" :style="{color: '#1890FF',position: 'relative',top: '-30px',left:flag?'calc(100% - 100px)':'calc(100% - 50px)',cursor: 'pointer'}">{{ time }}</div>
        </div>

        <div style="margin-left: 30px;font-size: 14px;color: black;margin-top: 30px;">密码</div>
        <el-input type="password" v-model="registerPass" placeholder="请输入密码" style="margin-top: 20px;margin-left: 30px;width: calc(100% - 60px);margin-right: 30px;"></el-input>
        <div style="margin-left: 30px;font-size: 14px;color: black;margin-top: 30px;">确认密码</div>
        <el-input type="password" v-model="registerPass2" placeholder="请再次输入密码" style="margin-top: 20px;margin-left: 30px;width: calc(100% - 60px);margin-right: 30px;"></el-input>
      </div>

      <div @click="forgetPassword" style="cursor: pointer;margin-top: 25px;margin-left: 30px;width: calc(100% - 60px);margin-right: 30px;background-color: #1890FF;color: white;border-radius: 25px;height: 40px;line-height: 40px;text-align: center;">确 认</div>
    </el-dialog>

    <el-dialog
      title=""
      :visible.sync="reservationPrompt"
      width="40%"
    >
      <div style="text-align: left;font-size: 16px;color: black;font-weight: 400;margin-left: 0px;margin-top: -40px;">预约信息</div>
      <div style="width: calc(100% - 20px);height: 1px;padding: 0 10px;background-color: #EEEEEE;margin-top: 10px;"></div>
      <div style="height: 100px;width: 100%;line-height: 100px;color: black;text-align: center;" v-if="haveNoOver">
        您已预约成功，请等待检测结果。
      </div>
      <div style="height: 100px;width: 100%;line-height: 100px;color: black;text-align: center;" v-else>
        您暂未预约或检测结果已发布。
      </div>
    </el-dialog>

    <el-dialog
      title=""
      :visible.sync="feedBack"
      width="40%"
    >
      <div style="text-align: left;font-size: 16px;color: black;font-weight: 400;margin-left: 0px;margin-top: -40px;">结果反馈</div>
      <div style="width: calc(100% - 20px);height: 1px;padding: 0 10px;background-color: #EEEEEE;margin-top: 10px;"></div>
      <el-input
        style="margin-top: 20px;margin-bottom: 20px;"
        type="textarea"
        :rows="4"
        :autosize="{ minRows: 4, maxRows: 8}"
        maxlength="200"
        show-word-limit
        placeholder="请填写反馈结果"
        v-model="content"
      >
      </el-input>
      
      <el-button type="primary" @click="toFeedBack">提交</el-button>
      <el-button @click="feedBack=false">取消</el-button>
    </el-dialog>

    <el-dialog
      title=""
      :visible.sync="reservationConditioning"
      width="40%"
    >
      <div style="text-align: left;font-size: 16px;color: black;font-weight: 400;margin-left: 0px;margin-top: -40px;">预约调理</div>
      <div style="width: calc(100% - 20px);height: 1px;padding: 0 10px;background-color: #EEEEEE;margin-top: 10px;"></div>
      <el-form ref="form" label-width="80px" style="margin-top: 20px;">
        <el-form-item label="姓名">
          <el-input v-model="conditioningName" :readonly="isShow"></el-input>
        </el-form-item>
        <el-form-item label="生日(阳历)">
          <el-input v-model="conditioningBirthday" readonly @click.native="conditioningShowTime(true)"></el-input>
        </el-form-item>
        <el-form-item label="生日(阴历)">
          <el-input v-model="conditioningLunarCalendare" readonly @click.native="conditioningShowTime(false)"></el-input>
        </el-form-item>
        <el-form-item label="曾用名">
          <el-input v-model="conditioningFormerName"  :readonly="isShow"></el-input>
        </el-form-item>
        <el-form-item label="婚姻状况">
          <el-radio-group v-model="conditioningMarry"  :readonly="isShow">
            <el-radio label="已婚" :disabled="isShow"></el-radio>
            <el-radio label="未婚" :disabled="isShow"></el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="预约时间">
          <el-date-picker  :readonly="isShow" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" placeholder="选择日期" v-model="conditioningTime" style="width: 100%;"></el-date-picker>
        </el-form-item>
        <el-form-item v-if="!isShow">
          <el-button type="primary" @click="toConditioning">预约</el-button>
          <el-button @click="reservationConditioning=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog
      title=""
      :visible.sync="reservation"
      width="40%"
    >
      <div style="text-align: left;font-size: 16px;color: black;font-weight: 400;margin-left: 0px;margin-top: -40px;">在线预约</div>
      <div style="width: calc(100% - 20px);height: 1px;padding: 0 10px;background-color: #EEEEEE;margin-top: 10px;"></div>
      <el-form ref="form" label-width="80px" style="margin-top: 20px;">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="姓名" required>
              <el-input v-model="reservationName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="性别" required>
              <el-radio-group v-model="reservationGender">
                <el-radio label="1">男</el-radio>
                <el-radio label="2">女</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="出生日期" required>
              <el-date-picker
                v-model="reservationBirthday"
                type="date"
                placeholder="选择出生日期"
                style="width: 100%;"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系电话" required>
              <el-input v-model="reservationPhone" placeholder="请输入您的联系电话"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="预约日期" required>
          <el-date-picker
            v-model="reservationDate"
            type="date"
            placeholder="选择预约日期"
            style="width: 100%;"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="toReservationClick">提交预约</el-button>
          <el-button @click="reservation=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    
    <YunshiCalendar  
      :showCalendar="conditioningIsShowTime" 
      @confirm="conditioningIsShowTimeSelectDate" 
      :type1="conditioningIsShowTimeType"
      :isHour="false" 
      :isActive1="conditioningIsShowTimeIsActive"
      @cancel="conditioningIsShowTime = false"
    >
    </YunshiCalendar >
    
    <YunshiCalendar  
      :showCalendar="reservationIsShowTime" 
      @confirm="reservationIsShowTimeSelectDate" 
      :type1="reservationIsShowTimeType"
      :isHour="false" 
      :isActive1="reservationIsShowTimeIsActive"
      @cancel="reservationIsShowTime = false"
    >
    </YunshiCalendar >
  </div>
</template>

<script>
import YunshiCalendar from '../../components/yunshui-calendar/yunshuiCalendar.vue'
import calendar from '../../components/calendar.js'
import { addFeedBack, reservation, getTodayNumber, getIsNoOver, getTotalNumber, getIsNoOverConditioning, getResult, sms, login, addUser, forgetPassword, conditioning } from "@/api/reservation"
import Cookies from 'js-cookie'

export default {
  name: "Index",
  components: {
    YunshiCalendar 
  },
  data() {
    return {
      // 原有数据
      isShow: false,
      reservationName: '',
      reservationGender: '1',
      reservationPhone: '',
      reservationDate: '',
      reservationFormerName: '',
      reservationMarry: '已婚',
      reservationBirthday: '',
      reservationLunarCalendare: '',
      reservationIsShowTime: false,
      reservationIsShowTimeIsActive: true,
      reservationIsShowTimeType: 'solar',
      feedBack: false,
      content: '',
      conditioningName: '',
      conditioningTime: '',
      conditioningFormerName: '',
      conditioningMarry: '已婚',
      conditioningBirthday: '',
      conditioningLunarCalendare: '',
      conditioningIsShowTimeIsActive: true,
      conditioningIsShowTimeType: 'solar',
      conditioningIsShowTime: false,
      reservationConditioning: false,
      reservationPrompt: false,
      loginName: '',
      loginPass: '',
      registerName: '',
      registerPass: '',
      registerPass2: '',
      registerCode: '',
      time: '获取验证码',
      timer: null,
      flag: true,
      register: false,
      forget: false,
      reservation: false,
      login: false,
      dialogVisible: false,
      imgList: [],
      screenHeight: 1000,
      screenWidth: 500,
      number: 20,
      phone: Cookies.get('phone'),
      haveNoOver: false,
      totalNumber: 0,
      conditioning: {},
      pdfUrl: 'https://quantum-health.oss-cn-hangzhou.aliyuncs.com/pdf018ab3b8-fc30-45ba-b9d9-0dd138ad7c0620230720.pdf',
      
      // 新增专家团队数据
      experts: [
        {
          avatar: '👨‍⚕️',
          name: '张医生',
          title: '量子健康检测专家',
          bio: '从事量子健康检测研究20余年，拥有丰富的临床经验'
        },
        {
          avatar: '👩‍⚕️',
          name: '李医生',
          title: '健康调理专家',
          bio: '擅长量子健康调理和健康养生指导'
        },
        {
          avatar: '👨‍⚕️',
          name: '王医生',
          title: '健康数据分析专家',
          bio: '专注于量子健康数据分析和创新应用'
        },
        {
          avatar: '👩‍⚕️',
          name: '刘医师',
          title: '健康管理师',
          bio: '提供个性化量子健康管理方案和指导'
        }
      ]
    }
  },
  created() {
    this.screenWidth = window.innerWidth
    this.screenHeight = window.innerHeight
    
    this.getNumber()
    this.getIsNoOverF()
    this.getTotalNumberF()
    this.getIsNoOverConditioningF()
  },
  activated() {
    this.screenWidth = window.innerWidth
    this.screenHeight = window.innerHeight
    
    this.getNumber()
    this.getIsNoOverF()
    this.getTotalNumberF()
    this.getIsNoOverConditioningF()
    console.log(this.$route.query)
    if(this.$route.query.type == 'appointment'){
      //走预约
      console.log("toReservation")
      this.toReservation()
    }
  },
  mounted() {
    this.screenWidth = window.innerWidth
    this.screenHeight = window.innerHeight
    
    this.getNumber()
    this.getIsNoOverF()
    this.getTotalNumberF()
    this.getIsNoOverConditioningF()
  },
  methods: {
    toIcp(){
      const beianUrl = 'https://beian.miit.gov.cn/';
          // 打开新窗口（_blank 表示新窗口，noopener noreferrer 提升安全性）
          window.open(beianUrl, '_blank', 'noopener noreferrer');
    },
    // 原有方法
    toFeedBack() {
      let _this = this
      if(!this.content) {
        _this.$message.error("请输入反馈内容")
        return;
      }
      addFeedBack(this.phone, this.content).then(data => {
        console.log(data)
        if(data.data == 1) {
          _this.$message.success("提交成功")
          _this.feedBack = false
          _this.content = ''
        } else {
          _this.$message.error("提交失败")
        }
      }).catch(error => {
        _this.$message.error(error)
      })
    },
    reservationIsShowTimeSelectDate(v) {
      console.log(v)
      let type = v.type
      let year = v.chooseYear.value
      let month = v.chooseMonth.value > 20 ? (v.chooseMonth.value - 20) : v.chooseMonth.value
      let day = v.chooseDay.value
      let flag = v.chooseMonth.value > 20 ? true : false
      if (type == 0) {
        this.reservationBirthday = year + "-" + (month < 10 ? ("0" + month) : month) + "-" + (day < 10 ? ("0" + day) : day)
        let lunar = calendar.calendarFormatter.solar2lunar(year, month, day)
        this.reservationLunarCalendare = lunar.gzYear + "年" + lunar.IMonthCn + lunar.IDayCn
      } else {
        let lunar = calendar.calendarFormatter.lunar2solar(year, month, day, flag)
        this.reservationBirthday = lunar.cYear + "-" + (lunar.cMonth < 10 ? ("0" + lunar.cMonth) : lunar.cMonth) + "-" + (lunar.cDay < 10 ? ("0" + lunar.cDay) : lunar.cDay)
        this.reservationLunarCalendare = lunar.gzYear + "年" + lunar.IMonthCn + lunar.IDayCn
      }
      this.reservationIsShowTime = false
    },
    reservationShowTime(v) {
      this.reservationIsShowTimeIsActive = v
      if (this.reservationIsShowTimeIsActive) {
        this.reservationIsShowTimeType = 'solar'
      } else {
        this.reservationIsShowTimeType = 'lunar'
      }
      this.reservationIsShowTime = true
    },
    conditioningIsShowTimeSelectDate(v) {
      let type = v.type
      let year = v.chooseYear.value
      let month = v.chooseMonth.value > 20 ? (v.chooseMonth.value - 20) : v.chooseMonth.value
      let day = v.chooseDay.value
      let flag = v.chooseMonth.value > 20 ? true : false
      if (type == 0) {
        this.conditioningBirthday = year + "-" + (month < 10 ? ("0" + month) : month) + "-" + (day < 10 ? ("0" + day) : day)
        let lunar = calendar.calendarFormatter.solar2lunar(year, month, day)
        this.conditioningLunarCalendare = lunar.gzYear + "年" + lunar.IMonthCn + lunar.IDayCn
      } else {
        let lunar = calendar.calendarFormatter.lunar2solar(year, month, day, flag)
        this.conditioningBirthday = lunar.cYear + "-" + (lunar.cMonth < 10 ? ("0" + lunar.cMonth) : lunar.cMonth) + "-" + (lunar.cDay < 10 ? ("0" + lunar.cDay) : lunar.cDay)
        this.conditioningLunarCalendare = lunar.gzYear + "年" + lunar.IMonthCn + lunar.IDayCn
      }
      this.conditioningIsShowTime = false
    },
    conditioningShowTime(v) {
      if (this.isShow) {
        return
      }
      this.conditioningIsShowTimeIsActive = v
      if (this.conditioningIsShowTimeIsActive) {
        this.conditioningIsShowTimeType = 'solar'
      } else {
        this.conditioningIsShowTimeType = 'lunar'
      }
      this.conditioningIsShowTime = true
    },
    toReservationClick() {
      let _this = this
      if(!this.reservationName) {
        _this.$message.error("请输入预约人姓名")
        return;
      }
      if(!this.reservationBirthday) {
        _this.$message.error("请选择预约人生日")
        return;
      }
      if(!this.reservationMarry) {
        _this.$message.error("请选择预约人婚姻状况")
        return;
      }
      let param = {}
      param.name = this.reservationName
      param.phone = this.phone
      param.former_name = this.reservationFormerName
      param.birthday = this.reservationBirthday
      param.marry = this.reservationMarry
      param.lunarBirthday = this.reservationLunarCalendare
      reservation(param).then(data => {
        console.log(data)
        if(data.data == 1) {
          _this.$message.success("预约成功")
          setTimeout(function() {
            _this.register = false
            location.reload()
          }, 1000);
        } else if(data.data == -1) {
          _this.$message.error("预约失败：今日预约已满请明日再试")
        } else if(data.data == -2) {
          _this.$message.error("预约失败：您今日已预约过了")
        } else if(data.data == -3) {
          _this.$message.error("预约失败：您已预约过了，请耐心等待结果")
        } else {
          _this.$message.error("预约失败")
        }
      }).catch(error => {
        _this.$message.error(error)
      })
    },
    toConditioning() {
      let _this = this
      if(!this.conditioningName) {
        _this.$message.error("请输入调理人姓名")
        return;
      }
      if(!this.conditioningBirthday) {
        _this.$message.error("请选择调理人生日")
        return;
      }
      if(!this.conditioningTime) {
        _this.$message.error("请选择预约日期")
        return;
      }
      if(!this.conditioningMarry) {
        _this.$message.error("请选择调理人婚姻状况")
        return;
      }
      let param = {}
      param.name = this.conditioningName
      param.phone = this.phone
      param.former_name = this.conditioningFormerName
      param.birthday = this.conditioningBirthday
      param.marry = this.conditioningMarry
      param.toTime = this.conditioningTime
      param.lunarBirthday = this.conditioningLunarCalendare
      conditioning(param).then(data => {
        console.log(data)
        if(data.data == 1) {
          _this.$message.success("预约成功")
          Cookies.remove('number');
          Cookies.remove('haveNoOver');
          Cookies.remove('totalNumber');
          setTimeout(function() {
            _this.register = false
            location.reload()
          }, 1000);
        } else {
          _this.$message.error("预约失败：您已预约过了")
        }
      }).catch(error => {
        _this.$message.error(error)
      })
    },
    conditioningClick(flag) {
      this.isShow = flag
      if (flag) {
        this.conditioningName = this.conditioning.name || ''
        this.conditioningBirthday = this.conditioning.birthday || ''
        this.conditioningFormerName = this.conditioning.former_name || ''
        this.conditioningMarry = this.conditioning.marry || '已婚'
        this.conditioningTime = this.conditioning.toTime || ''
        this.conditioningLunarCalendare = this.conditioning.lunar_birthday || ''
      } else {
        this.conditioningName = ''
        this.conditioningBirthday = ''
        this.conditioningFormerName = ''
        this.conditioningMarry = '已婚'
        this.conditioningTime = ''
        this.conditioningLunarCalendare = ''
      }
      if (!this.phone) {
        this.login = true
        return
      } else {
        this.reservationConditioning = true
      }
    },
    showPdf() {
      if(!this.phone) {
        this.login = true
        return
      }
      getResult(this.phone).then(data => {
        if(data.data) {
          let url = data.data.res_url
          window.open(url)
        } else {
          this.$message.error("暂无检测结果，请耐心等待")
        }
      }).catch(error => {
        this.$message.error(error)
      })
    },
    reservationPromptClick() {
      if (!this.phone) {
        this.login = true
        return
      } else {
        this.reservationPrompt = true
      }
    },
    toReservation() {
      if (!this.phone) {
        this.login = true
        return
      }
      if (this.haveNoOver || Cookies.get('haveNoOver')) {
        this.$message.error("存在未完成的预约。")
      } else {
        this.reservation = true
      }
    },
    forgetPassword() {
      let _this = this
      const reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
      if(!reg.test(this.registerName)) {
        _this.$message.error("请输入正确的手机号")
        return;
      }
      if(!this.registerPass) {
        _this.$message.error("密码不可为空")
        return;
      }
      if(this.registerPass !== this.registerPass2) {
        _this.$message.error("两次输入密码不一致")
        return;
      }
      if(!this.registerCode || this.registerCode.length != 4) {
        _this.$message.error("请输入正确的验证码")
        return;
      }
      forgetPassword(this.registerName, this.registerCode, this.registerPass).then(data => {
        console.log(data)
        if(data.data == 1) {
          _this.$message.success("修改成功，正在自动登陆")
          Cookies.set('phone', this.phone);
          setTimeout(function() {
            _this.register = false
            location.reload()
          }, 1000);
        } else if(data.data.resCode == -2) {
          _this.$message.error("验证码错误")
        } else {
          _this.$message.error("修改失败")
        }
      }).catch(error => {
        _this.$message.error(error)
      })
    },
    siginIn() {
      let _this = this
      const reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
      if(!reg.test(this.registerName)) {
        _this.$message.error("请输入正确的手机号")
        return;
      }
      if(!this.registerPass) {
        _this.$message.error("密码不可为空")
        return;
      }
      if(this.registerPass !== this.registerPass2) {
        _this.$message.error("两次输入密码不一致")
        return;
      }
      if(!this.registerCode || this.registerCode.length != 4) {
        _this.$message.error("请输入正确的验证码")
        return;
      }
      let param = {}
      param.phone = this.registerName
      param.password = this.registerPass
      param.code = this.registerCode
      addUser(param).then(data => {
        console.log(data)
        if(data.data.resCode == 1) {
          _this.$message.success("注册成功，正在自动登陆")
          Cookies.remove('cont');
          Cookies.set('phone', data.data.phone);
          setTimeout(function() {
            _this.register = false
            location.reload()
          }, 1000);
        } else if(data.data.resCode == -2) {
          _this.$message.error("验证码错误")
        } else if(data.data.resCode == -1) {
          _this.$message.error("当前手机号已注册")
        } else {
          _this.$message.error("注册失败")
        }
      }).catch(error => {
        _this.$message.error(error)
      })
    },
    sendSms() {
      let _this = this
      const reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
      if (!reg.test(this.registerName)) {
        _this.$message.error("请输入正确的手机号")
        return
      }
      if (this.flag) {
        // 使用临时数据模拟成功
        _this.$message.success("发送成功")
        _this.flag = false
        _this.time = 60
        _this.timer = setInterval(() => {
          _this.time--
          if (_this.time == 0) {
            _this.time = '获取验证码'
            clearInterval(_this.timer)
            _this.flag = true
          }
        }, 1000)
      }
    },
    logout() {
      this.$message.success("操作成功")
      Cookies.remove('phone')
      setTimeout(() => {
        location.reload()
      }, 1000)
    },
    loginF() {
      let _this = this
      const reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
      if(!reg.test(this.loginName)) {
        _this.$message.error("请输入正确的手机号")
        return;
      }
      if(!this.loginPass) {
        _this.$message.error("密码不可为空")
        return;
      }
      let param = {}
      param.phone = this.loginName
      param.password = this.loginPass
      login(param).then(data => {
        console.log(data)
        if(data.data) {
          _this.$message.success("登陆成功")
          Cookies.remove('cont');
          Cookies.set('phone', data.data.phone);
          setTimeout(function() {
            _this.login = false
            location.reload()
          }, 1000);
        } else {
          _this.$message.error("登陆失败：手机号或密码错误")
        }
      }).catch(error => {
        _this.$message.error(error)
      })
    },
    toFeedback() {
      this.$router.push({
        path: '/phone/feedback'
      })
    },
    out() {
      // 删除cookie
      Cookies.remove('phone')
      this.$router.push({
        path: '/phone/login'
      })
    },
    getNumber() {
      getTodayNumber().then(data => {
        this.number = data.data
        Cookies.set('number', data.data);
      }).catch(error => {
        this.$message.error(error)
      })
    },
    getIsNoOverF() {
      if(this.phone) {
        getIsNoOver(this.phone).then(data => {
          if(data.data >= 1) {
            this.haveNoOver = true;
          } else {
            this.haveNoOver = false;
          }
          Cookies.set('haveNoOver', this.haveNoOver );
        }).catch(error => {
          this.$message.error(error)
        })
      }
    },
    getTotalNumberF() {
      getTotalNumber(this.phone).then(data => {
        this.totalNumber = data.data;
        Cookies.set('totalNumber', this.totalNumber );
      }).catch(error => {
        this.$message.error(error)
      })
    },
    getIsNoOverConditioningF() {
      getIsNoOverConditioning(this.phone).then(data => {
        this.conditioning = data.data;
      }).catch(error => {
        this.$message.error(error)
      })
    },
    // 新增页面跳转方法
    goToHealthDetection() {
      this.$router.push('/health-detection')
    },
    goToExpertTeam() {
      this.$router.push('/expert-team')
    },
    goToHealthManagement() {
      this.$router.push('/health-management')
    },
    goToConditioningService() {
      this.$router.push('/conditioning-service')
    },
    goToNewsDetail() {
      this.$router.push('/news')
    },
    goToCaseDetail() {
      this.$router.push('/cases')
    },
    goToAppointmentService() {
      this.$router.push('/appointment-service')
    }
  }
}
</script>

<style lang="scss" scoped>
/* 全局样式 */
.health-website {
  font-family: 'Arial', sans-serif;
  color: #333;
  line-height: 1.6;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.section-title {
  text-align: center;
  font-size: 2.5rem;
  color: #2c3e50;
  margin-bottom: 2rem;
  position: relative;
  
  &::after {
    content: '';
    position: absolute;
    bottom: -10px;
    left: 50%;
    transform: translateX(-50%);
    width: 80px;
    height: 4px;
    background-color: #3498db;
    border-radius: 2px;
  }
}

/* 导航栏样式 */
.navbar {
  background-color: rgba(255, 255, 255, 0.95);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  transition: all 0.3s ease;
}

.navbar {
  padding: 0 20px;
}

.navbar .container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 0;
  width: 100%;
}

.logo {
  width: 414.34px;
  display: flex;
  align-items: center;
  font-size: 1.2rem;
  font-weight: bold;
  color: #2c3e50;
  
  img {
    height: 40px;
    margin-right: 8px;
  }
}

.nav-links {
  display: flex;
  gap: 1.5rem;
  justify-content: center;
  flex: 1;
  flex-wrap: wrap;
  padding: 0.5rem 1rem;
  align-items: center;
  
  a, .nav-link {
    color: #2c3e50;
    text-decoration: none;
    font-weight: 500;
    transition: all 0.3s ease;
    padding: 0.5rem 0;
    position: relative;
    white-space: nowrap;
    font-size: 0.95rem;
    cursor: pointer;
    
    &:hover,
    &.active,
    &.router-link-exact-active {
      color: #3498db;
    }
    
    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      width: 0;
      height: 2px;
      background-color: #3498db;
      transition: width 0.3s ease;
    }
    
    &:hover::after,
    &.active::after {
      width: 100%;
    }
    
    &.btn-accent {
      background-color: #3498db;
      color: white;
      padding: 0.6rem 1.8rem;
      border-radius: 25px;
      font-weight: 600;
      box-shadow: 0 2px 8px rgba(52, 152, 219, 0.3);
      
      &:hover {
        background-color: #2980b9;
        color: white;
        box-shadow: 0 4px 12px rgba(41, 128, 185, 0.4);
        transform: translateY(-1px);
      }
      
      &::after {
        display: none;
      }
    }
  }
}

.user-actions {
  display: flex;
  gap: 1rem;
  align-items: center;
  margin-left: auto;
}

.user-actions .login-btn {
  margin-left: auto;
}

.nav-btn {
  background: none;
  border: none;
  color: #2c3e50;
  cursor: pointer;
  font-weight: 500;
  transition: color 0.3s ease;
  
  &:hover {
    color: #3498db;
  }
}

.login-btn {
  background-color: #3498db;
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  
  &:hover {
    background-color: #2980b9;
    color: white;
  }
}

/* 首页轮播样式 */
.hero {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  text-align: center;
  padding: 120px 20px 80px;
  margin-bottom: 4rem;
}

.hero-content {
  max-width: 800px;
  margin: 0 auto;
}

.hero h1 {
  font-size: 3.5rem;
  margin-bottom: 1rem;
  line-height: 1.2;
}

.hero p {
  font-size: 1.2rem;
  margin-bottom: 2rem;
  opacity: 0.9;
}

.hero-buttons {
  display: flex;
  gap: 1rem;
  justify-content: center;
  align-items: center;
  margin: 2rem 0;
  flex-wrap: wrap;
}

.cta-btn {
  background-color: #fff;
  color: #667eea;
  padding: 1rem 2.5rem;
  font-size: 1.1rem;
  border: none;
  border-radius: 50px;
  cursor: pointer;
  font-weight: bold;
  transition: all 0.3s ease;
  
  &.primary {
    background-color: #667eea;
    color: white;
    
    &:hover {
      background-color: #5a6fd8;
      transform: translateY(-2px);
      box-shadow: 0 5px 15px rgba(102, 126, 234, 0.4);
    }
  }
  
  &.secondary {
    background-color: rgba(255, 255, 255, 0.9);
    color: #667eea;
    border: 2px solid #667eea;
    
    &:hover {
      background-color: #667eea;
      color: white;
      transform: translateY(-2px);
      box-shadow: 0 5px 15px rgba(102, 126, 234, 0.3);
    }
  }
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
  }
}

.hero-info {
  margin-top: 2rem;
  font-size: 1rem;
  opacity: 0.9;
}

/* 公司介绍样式 */
.about {
  padding: 4rem 0;
  background-color: #f9f9f9;
  
  .about-content {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 3rem;
    align-items: center;
  }
  
  .about-text h3 {
    font-size: 2rem;
    margin-bottom: 1rem;
    color: #2c3e50;
  }
  
  .about-text p {
    margin-bottom: 1rem;
    color: #666;
  }
  
  .about-image {
    background-color: #e0e0e0;
    height: 300px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    overflow: hidden;
    
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
    }
  }
}

/* 核心服务样式 */
.services {
  padding: 4rem 0;
  
  .services-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 2rem;
    margin-top: 3rem;
  }
  
  .service-card {
    background-color: white;
    padding: 2rem;
    border-radius: 8px;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
    text-align: center;
    transition: transform 0.3s ease;
    cursor: pointer;
    
    &:hover {
      transform: translateY(-5px);
      box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
    }
  }
  
  .service-icon {
    font-size: 3rem;
    margin-bottom: 1rem;
  }
  
  .service-card h3 {
    font-size: 1.5rem;
    margin-bottom: 0.5rem;
    color: #2c3e50;
  }
  
  .service-card p {
    color: #666;
  }
}

/* 专家团队样式 */
.experts {
  padding: 4rem 0;
  background-color: #f9f9f9;
  
  .experts-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 2rem;
    margin-top: 3rem;
  }
  
  .expert-card {
    background-color: white;
    padding: 2rem;
    border-radius: 8px;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
    text-align: center;
    transition: all 0.3s ease;
    cursor: pointer;
    
    &:hover {
      transform: translateY(-5px);
      box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
    }
  }
  
  .expert-avatar {
    font-size: 4rem;
    margin-bottom: 1rem;
  }
  
  .expert-card h3 {
    font-size: 1.3rem;
    margin-bottom: 0.3rem;
    color: #2c3e50;
  }
  
  .expert-title {
    color: #3498db;
    font-weight: 500;
    margin-bottom: 0.8rem;
  }
  
  .expert-bio {
    color: #666;
    font-size: 0.9rem;
  }
}

/* 行业资讯样式 */
.news {
  padding: 4rem 0;
  
  .news-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 2rem;
    margin-top: 3rem;
  }
  
  .news-card {
    background-color: white;
    padding: 1.5rem;
    border-radius: 8px;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease;
    cursor: pointer;
    
    &:hover {
      transform: translateY(-5px);
      box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
    }
  }
  
  .news-date {
    color: #3498db;
    font-size: 0.9rem;
    margin-bottom: 1rem;
  }
  
  .news-card h3 {
    font-size: 1.3rem;
    margin-bottom: 1rem;
    color: #2c3e50;
  }
  
  .news-card p {
    color: #666;
    margin-bottom: 1.5rem;
    line-height: 1.6;
  }
  
  .read-more {
    color: #3498db;
    text-decoration: none;
    font-weight: 500;
    transition: color 0.3s ease;
    
    &:hover {
      color: #2980b9;
    }
  }
}

/* 常见问题样式 */
.faq {
  padding: 4rem 0;
  background-color: #f9f9f9;
  
  .faq-list {
    max-width: 800px;
    margin: 3rem auto 0;
  }
  
  .faq-item {
    background-color: white;
    border-radius: 8px;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
    margin-bottom: 1rem;
    overflow: hidden;
  }
  
  .faq-question {
    font-size: 1.2rem;
    padding: 1.5rem;
    margin: 0;
    color: #2c3e50;
    cursor: pointer;
    transition: background-color 0.3s ease;
    
    &:hover {
      background-color: #f5f5f5;
    }
  }
  
  .faq-answer {
    padding: 0 1.5rem 1.5rem;
    color: #666;
    line-height: 1.6;
  }
}

/* 知识产权样式 */
.intellectual-property {
  padding: 4rem 0;
  
  .ip-section {
    margin-bottom: 3rem;
  }
  
  .ip-title {
    font-size: 1.8rem;
    margin-bottom: 1.5rem;
    color: #2c3e50;
  }
  
  .ip-content {
    background-color: white;
    padding: 2rem;
    border-radius: 8px;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  }
  
  .ip-content p {
    margin-bottom: 1.5rem;
    color: #666;
    line-height: 1.6;
  }
  
  .ip-list {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 1rem;
  }
  
  .ip-item {
    padding: 1rem;
    background-color: #f9f9f9;
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }
  
  .ip-number {
    font-weight: 500;
    color: #3498db;
    font-size: 0.9rem;
  }
  
  .ip-name {
    color: #2c3e50;
    font-weight: 600;
  }
  
  .view-more {
    text-align: center;
    margin-top: 1.5rem;
    color: #1890FF;
    font-weight: 500;
    font-size: 1rem;
    transition: color 0.3s ease;
    
    &:hover {
      color: #40a9ff;
    }
  }
}

/* 成功案例样式 */
.cases {
  padding: 4rem 0;
  background-color: #f9f9f9;
  
  .cases-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 2rem;
    margin-top: 3rem;
  }
  
  .case-card {
    background-color: white;
    border-radius: 8px;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
    overflow: hidden;
    transition: all 0.3s ease;
    cursor: pointer;
    
    &:hover {
      transform: translateY(-5px);
      box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
    }
  }
  
  .case-image {
    background-color: #e0e0e0;
    height: 200px;
    border-radius: 8px;
    overflow: hidden;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
    }
  }
  
  .image-placeholder {
    font-size: 1.2rem;
    color: #888;
  }
  
  .case-content {
    padding: 1.5rem;
  }
  
  .case-content h3 {
    font-size: 1.3rem;
    margin-bottom: 1rem;
    color: #2c3e50;
  }
  
  .case-content p {
    color: #666;
    line-height: 1.6;
  }
}

/* 联系我们样式 */
.contact {
  padding: 4rem 0;
  
  .contact-content {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 3rem;
  }
  
  .contact-info h3 {
    font-size: 2rem;
    margin-bottom: 1.5rem;
    color: #2c3e50;
  }
  
  .contact-info p {
    margin-bottom: 1rem;
    color: #666;
  }
  
  .contact-form h3 {
    font-size: 2rem;
    margin-bottom: 1.5rem;
    color: #2c3e50;
  }
  
  .submit-btn {
    background-color: #3498db;
    border: none;
    padding: 0.8rem 2rem;
    border-radius: 4px;
    font-size: 1rem;
    
    &:hover {
      background-color: #2980b9;
    }
  }
}

/* 底部样式 */
.footer {
  background-color: #263238;
  color: white;
  padding: 3rem 0 1rem;
  
  .footer-content {
    display: grid;
    grid-template-columns: 0.4fr 0.6fr;
    gap: 3rem;
    margin-bottom: 2rem;
  }
  
  .footer-links-group {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 2rem;
  }
  
  .footer-info h3 {
    font-size: 1.5rem;
    margin-bottom: 1.5rem;
    color: #fff;
  }
  
  .footer-info p {
    margin-bottom: 0.8rem;
    color: rgba(255, 255, 255, 0.8);
  }
  
  .contact-info {
    margin-top: 1rem;
  }
  
  .contact-info p {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 0.9rem;
  }
  
  .footer-links, .footer-services, .footer-social {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }
  
  .footer-links h4, .footer-services h4, .footer-social h4 {
    font-size: 1.2rem;
    margin-bottom: 0.5rem;
    color: #fff;
    position: relative;
    padding-bottom: 8px;
    
    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      width: 40px;
      height: 2px;
      background-color: #3498db;
    }
  }
  
  .footer-links a, .footer-services a, .footer-social a {
    color: rgba(255, 255, 255, 0.8);
    text-decoration: none;
    transition: all 0.3s ease;
    font-size: 0.9rem;
    
    &:hover {
      color: #3498db;
      padding-left: 5px;
    }
  }
  
  .social-icons {
    display: flex;
    flex-direction: column;
    gap: 0.8rem;
  }
  
  .social-icon {
    display: flex;
    align-items: center;
    gap: 8px;
  }
  
  .footer-bottom {
    border-top: 1px solid rgba(255, 255, 255, 0.1);
    padding-top: 1rem;
    text-align: center;
  }
  
  .copyright {
    opacity: 0.8;
  }
  
  .copyright p {
    margin: 0;
    font-size: 12px;
  }
}

/* 原有弹窗样式 */
.noInput ::v-deep input {
  border: 0px;
  border-bottom: 1px solid #D2D2D2;
  border-radius: 0px;
  padding: 0;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .nav-links {
    display: none;
  }
  
  .hero h1 {
    font-size: 2.5rem;
  }
  
  .about-content,
  .contact-content {
    grid-template-columns: 1fr;
  }
  
  .services-grid,
  .experts-grid {
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  }
}
</style>